var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.updateAvailable)?_c('a',{staticClass:"client-version update",attrs:{"title":`Update to ${_vm.version}`,"href":_vm.path},on:{"click":_vm.reload}},[_vm._v("Update to "+_vm._s(_vm.version))]):_c('span',{staticClass:"client-version",attrs:{"title":_vm.version}},[_vm._v(_vm._s(_vm.version))])
}
var staticRenderFns = []

export { render, staticRenderFns }